import React, { useCallback, useState } from 'react';
import useTranslations from '../../hooks/useTranslations';
import Colors from '../../internal-components/Colors';
import ColorPickerView from '../view/ColorPickerView';

export const BUTTON_VARIANT = {
  PALLETE: 'p',
  BOX: 'b'
};

const ColorPickerEngine = ({
  defaultColor = Colors.PRIMARY,
  onColorSelected = color => color,
  tooltipText,
  buttonVariant = BUTTON_VARIANT.BOX,
  ...props
}) => {
  const [isPickerShowing, setIsPickerShowing] = useState(false);
  const [activeColor, setActiveColor] = useState(defaultColor);

  const t = useTranslations();

  const onChangeComplete = useCallback(
    color => {
      setActiveColor(color.hex);
      onColorSelected(color.hex);
    },
    [onColorSelected]
  );

  const viewProps = {
    setIsPickerShowing,
    isPickerShowing,
    defaultColor,
    onChangeComplete,
    activeColor,
    tooltipText: tooltipText
      ? tooltipText
      : t('colorPicker.tooltip.defaultText'),
    buttonVariant
  };

  return <ColorPickerView {...viewProps} />;
};

export default ColorPickerEngine;
